import { IonSpinner } from '@ionic/react';
import { useHistory } from 'react-router';
import { Header } from '../components/Header';
import { IconButton } from '../components/IconButton';
import { PostContentsToHTML } from '../components/PostContentsToHTML';
import { IconArrowBack } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
import { QuirkIonPage } from '../components/QuirkIonPage';
import { howToFormatPostsText } from '../markdownPages/HowToFormatPostsText';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';
import { useGetPublicInformationQuery } from '../api/SiteSettingsAPI.js';
export const HowToFormatPosts: React.FC = () => {
	const { data: siteSettings } = useGetPublicInformationQuery();
	const history = useHistory();

	return (
		<QuirkIonPage roles={['anonymous', 'user']}>
			{!siteSettings ? (
				<QuirkIonContent fullscreen={true}>
					<div className="center-align">
						<IonSpinner color="primary" />
					</div>
				</QuirkIonContent>
			) : (
				<>
					<Header
						title="How to format posts"
						left={<IconButton icon={<IconArrowBack />} onClick={() => history.go(-1)} />}
					/>
					<QuirkIonContent>
						<div className={sharedStyles.contentWrapper}>
							<PostContentsToHTML>{howToFormatPostsText}</PostContentsToHTML>
						</div>
					</QuirkIonContent>
				</>
			)}
		</QuirkIonPage>
	);
};
